export const locale = {
    lang: 'pl',
    data: {
        'Calendar': 'Kalendarz',
        'New reservation': 'Nowa rezerwacja',
        'Today': 'Dzisiaj',
        'Tomorrow': 'Jutro',
        '7 days': '7 dni',
        'Month': 'Miesiąc',
        'Year': 'Rok',
        'Service': 'Usługa',
        'Name': 'Nazwa',
        'Hour': 'Godzina',
        'Minute': 'Minuta',
        'Worker': 'Pracownik',
        'Customer': 'Klient',
        'ADD': 'Dodaj',
        'Workers': 'Pracownicy',
        'Resources': 'Zasoby',
        'Start date': 'Od',
        'End date': 'Do',
        'Day': 'Dzień',
        'Visit': 'Wizyta',
        'Add customer': 'Dodaj klienta',
        'Display invisible': 'Pokaż niewidoczne',
        'Impossible to create reservation!': 'Nie można utworzyć nowej rezerwacji!',
        'Trainer': 'Trener',
        'Number of contestants': 'Ilość uczestników',
        'Add participant': 'Dodaj uczestnika',
        'Group activity': 'Zajęcia grupowe',
        'Participant': 'Uczestnik',
        'Confirmed': 'Potwierdzony',
        'Took part in': 'Wziął udział',
        'Yes': 'Tak',
        'No': 'Nie',
        'Actions': 'Akcje',
        'Confirm your willingness to participate': 'Potwierdź chęć udziału',
        'Delete participant': 'Usuń uczestnika',
        'Phone number': 'Numer telefonu'
    }
};
